import { useEffect } from 'react';

const FontAwesomeLoader = () => {
  useEffect(() => {
    // Ensure Font Awesome CSS is loaded
    const linkId = 'font-awesome-css';
    let link = document.getElementById(linkId);
    
    if (!link) {
      link = document.createElement('link');
      link.id = linkId;
      link.rel = 'stylesheet';
      link.href = 'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.2/css/all.min.css';
      link.crossOrigin = 'anonymous';
      link.referrerPolicy = 'no-referrer';
      document.head.appendChild(link);
    }
  }, []);

  return null;
};

export default FontAwesomeLoader;

